import { render } from "./TheDegree.vue?vue&type=template&id=94c70d68&scoped=true"
import script from "./TheDegree.vue?vue&type=script&lang=js"
export * from "./TheDegree.vue?vue&type=script&lang=js"

import "./TheDegree.vue?vue&type=style&index=0&id=94c70d68&scoped=true&lang=css"

import exportComponent from "/home/cyrill/Projects/kmapper/repos/cyrill.codeberg.page/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-94c70d68"]])

export default __exports__